import {
    GET_AUCTIONS, GET_INQUIRY, GET_INQUIRY_PRICE, GET_SUPPLIER_PRICE,
    GET_TENDERS, POST_INQUIRY_PRICE, SUPPLIER_PRICE
} from "./action_type";
import {getApi, getWithoutLocalApi, postApi} from "../../data/ApiService";
import {SET_AUCTION, SET_ERROR, SET_INQUIRY, SET_INQUIRY_PRICE, SET_LOADING, SET_TENDERS} from "./mutation_types";


export default {
    async [GET_AUCTIONS]({commit}) {
        commit(SET_LOADING, true);
        try {
            const response = await getApi('category/17/page/1/count/100');
            console.log(response.data);
            commit(SET_AUCTION, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },

    async [GET_TENDERS]({commit}) {
        commit(SET_LOADING, true);
        try {
            const response = await getApi('category/16/page/1/count/100');
            console.log(response);
            commit(SET_TENDERS, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },

    async [GET_INQUIRY]({commit},page) {
        commit(SET_LOADING, true);
        try {
            const response = await getApi(`topics/15/page/${page}/count/10`);
            console.log(response);
            commit(SET_INQUIRY, response);
        } catch (e) {
            console.log("inquiry error",e)
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [POST_INQUIRY_PRICE]({commit},payload) {
        commit(SET_LOADING, true);
        try {
            const response = await postApi(`suppliers/${payload.id}/inquiry_prices?inquiry_id=${payload.inquiry_id}&amount=${payload.amount}&price=${payload.price}`);
            console.log('GET_INQUIRY_PRICE',response);
        } catch (e) {
            console.log(e)
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
    async [GET_SUPPLIER_PRICE]({commit},payload) {
        commit(SET_LOADING, true);
        try {
            const response = await getWithoutLocalApi(`inquiries/${payload.id}/supplier_prices`);
            console.log('GET_INQUIRY_PRICE',response);
            commit(SET_INQUIRY_PRICE, response);
        } catch (e) {
            commit(SET_ERROR, e.response.message);
        } finally {
            commit(SET_LOADING, false);
        }
    },
}